import api from "@/api"

const state = {
  priceAdjustmentList: [],
  priceAdjustmentMeta: {}
}

const actions = {
  getPriceAdjustments({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.priceAdjustments(params).then(
        (response) => {
          commit("setPriceAdjustments", response.data.data)
          commit("setPriceAdjustmentMeta", response.data.meta)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  completePriceAdjustment({ commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.completePriceAdjustment(orderId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  rejectPriceAdjustment({ commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.rejectPriceAdjustment(orderId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setPriceAdjustments(state, value) {
    state.priceAdjustmentList = value
  },
  setPriceAdjustmentMeta(state, value) {
    state.priceAdjustmentMeta = value
  }
}

const getters = {
  priceAdjustmentList: (state) => state.priceAdjustmentList,
  priceAdjustmentMeta: (state) => state.priceAdjustmentMeta
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
